export default __webpack_public_path__ + "media/ui/icons-5cc8281c.svg";